import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchMe } from '@/shared/api/auth';
import { useAuthStore } from '@/shared/auth/store';
import { LoadingSpinner } from '@/shared/ui/LoadingSpinner';
import { ErrorState } from '@/shared/ui/ErrorState';

/**
 * Stage 5-F — Kakao OAuth 콜백. URL token 을 auth store 에 넣고 /me 조회 후 홈으로.
 */
export default function OAuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const setAuth = useAuthStore((s) => s.setAuth);
  const pendingInviteToken = useAuthStore((s) => s.pendingInviteToken);
  const [error, setError] = useState<string | null>(null);
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const token = params.get('token');
    if (!token) {
      setError('로그인 토큰이 전달되지 않았어요.');
      return;
    }
    useAuthStore.setState({ accessToken: token });
    (async () => {
      try {
        const me = await fetchMe();
        setAuth(token, { id: me.id, nickname: me.nickname, provider: me.provider });
        if (pendingInviteToken) {
          navigate(`/invite/${pendingInviteToken}`, { replace: true });
        } else {
          navigate('/home', { replace: true });
        }
      } catch {
        setError('로그인 정보를 가져오지 못했어요.');
        useAuthStore.getState().logout();
      }
    })();
  }, [params, pendingInviteToken, navigate, setAuth]);

  if (error) {
    return (
      <ErrorState
        title="로그인을 완료하지 못했어요"
        description={error}
        onRetry={() => navigate('/login', { replace: true })}
        retryLabel="로그인으로 돌아가기"
      />
    );
  }
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <LoadingSpinner size="lg" label="로그인 처리 중…" />
    </div>
  );
}
